import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck, Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { apiErr } from "../../lib/api";
import { LOGO_URL } from "../../lib/constants";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) { toast.error(apiErr(err)); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen grain-dark grid place-items-center px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 justify-center mb-8">
          <img src={LOGO_URL} alt="UBM" className="h-14 w-14 object-contain" />
          <div className="text-white font-display font-bold text-xl">UBM Admin</div>
        </div>
        <form onSubmit={submit} className="bg-white rounded-md p-8 shadow-xl">
          <div className="flex items-center gap-2 text-charcoal-900 mb-6"><ShieldCheck className="text-primary" /><h1 className="text-xl font-semibold">Administrator Login</h1></div>
          <label className="block text-sm font-medium text-charcoal-700 mb-1">Email</label>
          <input type="email" className="w-full border border-gray-300 rounded-md px-4 py-2.5 mb-4 focus:border-primary focus:ring-1 focus:ring-primary outline-none" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" />
          <label className="block text-sm font-medium text-charcoal-700 mb-1">Password</label>
          <input type="password" className="w-full border border-gray-300 rounded-md px-4 py-2.5 mb-6 focus:border-primary focus:ring-1 focus:ring-primary outline-none" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
          <button type="submit" disabled={loading} className="w-full bg-primary text-white hover:bg-primary-hover font-semibold px-6 py-3 rounded-md transition-colors disabled:opacity-60 inline-flex items-center justify-center gap-2" data-testid="admin-login-submit">
            {loading ? <><Loader2 className="animate-spin" size={18} /> Signing in…</> : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
